module.exports = {
  'MarkerAdded': 'MarkerAdded',
  'MarkerRemoved': 'MarkerRemoved',
  'ApiLoaded': 'ApiLoaded',
  'CentreChanged': 'CentreChanged',
  'PlacesChanged': 'PlacesChanged',
  'MarkerMoved': 'MarkerMoved'
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3dvcmsvc3JjL3N0YXRlL0FjdGlvbk5hbWVzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi93b3JrL3NyYy9zdGF0ZS9BY3Rpb25OYW1lcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFDLE9BQVAsR0FBaUI7RUFDaEIsZUFBQSxhQURnQjtFQUVoQixpQkFBQSxlQUZnQjtFQUdoQixhQUFBLFdBSGdCO0VBSWhCLGlCQUFBLGVBSmdCO0VBS2hCLGlCQUFBLGVBTGdCO0VBTWhCLGVBQUEsYUFOZ0IifQ==
